import React from 'react';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import type { RetainedBeaconChoice, RetainedBeaconEligibility } from '@/hooks/useRetainedBeaconDischarge';

interface Props {
  value: RetainedBeaconChoice | null;
  onChange: (choice: RetainedBeaconChoice) => void;
  eligibility?: RetainedBeaconEligibility | null;
}

export function RetainedBeaconDischargeChoice({ value, onChange, eligibility }: Props) {
  const scheduledStart = eligibility?.scheduledStart ? new Date(eligibility.scheduledStart).toLocaleString() : null;

  return (
    <FormControl component="fieldset" required fullWidth>
      <FormLabel component="legend">This patient has another scheduled procedure. Choose how to discharge.</FormLabel>
      <RadioGroup value={value || ''} onChange={event => onChange(event.target.value as RetainedBeaconChoice)}>
        <FormControlLabel value="standard" control={<Radio color="primary" />} label="Standard discharge" />
        <FormControlLabel value="retain" control={<Radio color="primary" />} label="Discharge and keep beacon" />
      </RadioGroup>
      {scheduledStart && <Typography variant="body2">Next scheduled procedure: {scheduledStart}</Typography>}
      {value === 'retain' && (
        <Typography variant="body2">
          Tell the patient to keep the beacon with them while remaining in the hospital.
        </Typography>
      )}
    </FormControl>
  );
}
